'use client';

import React from 'react';
import { VStack } from '@skin-seoul/design-system';
import { useProductService, type TaxonomyCategory } from '@skin-seoul/service';
import SuitableForItem from '@/containers/product-detail/sections/SuitableForSection/components/SuitableForItem';
import SectionContainer from '../../components/SectionContainer';
interface SuitableForSectionProps {
  productId: string;
}
const SuitableForSection = ({
  productId
}: SuitableForSectionProps) => {
  const {
    useGetProductMeta
  } = useProductService();
  const {
    data: productMeta
  } = useGetProductMeta({
    productId
  });
  const {
    skinType,
    skinConcern,
    efficacy
  } = productMeta.taxonomies;
  const suitableForItems: Array<{
    category: TaxonomyCategory;
    items: Array<{
      name: string;
      slug: string;
    }>;
  }> = [{
    category: 'skinType',
    items: skinType
  }, {
    category: 'skinConcern',
    items: skinConcern
  }, {
    category: 'efficacy',
    items: efficacy
  }];
  const hasAnySuitableForContent = suitableForItems.some(({
    items
  }) => items.length > 0);
  if (!hasAnySuitableForContent) {
    return null;
  }
  return <SectionContainer headerTitle="Suitable for" data-sentry-element="SectionContainer" data-sentry-component="SuitableForSection" data-sentry-source-file="SuitableForSection.tsx">
      <VStack gap={6} width="100%" alignItems="flex-start" data-sentry-element="VStack" data-sentry-source-file="SuitableForSection.tsx">
        {suitableForItems.map(({
        category,
        items
      }) => <SuitableForItem key={category} category={category} items={items} />)}
      </VStack>
    </SectionContainer>;
};
export default SuitableForSection;